// Constants for strings that aren't screen variables.

import { LeaseStatus } from '@zg-rentals/rental-manager-env';

// Enums related to screens.  Other enums go in Types.tsx

export enum GENDERS {
  MALE = 'male',
  FEMALE = 'female',
}

export enum PET_TYPES {
  DOG = 'dog',
  CAT = 'cat',
}

export enum MOBILE_HANDOFF_TYPES {
  CLOSED = 'closed',
  CANCEL_SIGNING = 'cancelSigning',
  REQUEST_SIGNATURE = 'requestSignature',
  LEASE_EDIT = 'leaseEdit',
  LEASE_HELP = 'leaseHelp',
  DOWNLOAD_PDF = 'downloadPdf',
  RETURN_TO_DASHBOARD = 'returnToDashboard',
  DOWNLOAD_EXPLAINER_LEASE = 'downloadExplainerLease',
  DOWNLOAD_SHARE_DRAFT = 'downloadShareDraft',
  DOWNLOAD_DRAFT_PDF = 'downloadDraftPdf',
  REQUEST_SIGNATURE_BLOCKER = 'requestSignatureBlocker',
}

export enum PERSON_TYPE {
  LANDLORD = 'landlord',
  GUARANTOR = 'guarantor',
  PROPERTY_MANAGER = 'propertyManager',
  TENANT = 'tenant',
  COLANDLORD = 'colandlord',
  PROPERTY_OWNER = 'propertyOwner',
}

export enum PERSON_TYPE_IDENTIFIER {
  COLANDLORD = '1',
}

export enum BRAND_NAMES {
  TRULIA = 'trulia',
  HOTPADS = 'hotpads',
  ZILLOW = 'zillow',
}

export enum APPLICATION_STATUS_TYPES {
  COMPLETED = 'completed',
  PENDING = 'pending',
  INVITED = 'invited',
  WITHDRAWN = 'withdrawn',
  ACCEPTED = 'accepted', // Deprecated by applications
  ACTIVE = 'active',
  INVITED_TO_MOVE_IN = 'invited_to_move_in',
}

export enum APPLICATION_RENTAL_PROTECTION_STATUSES {
  ELIGIBLE = 'eligible',
  INELIGIBLE = 'ineligible',
}

export enum APPLICANT_STATUSES {
  PENDING = 'pending',
  COMPLETED = 'completed',
  INVITED = 'invited',
  WITHDRAWN = 'withdrawn',
}

// Regex

export const EMAIL_REGEX = /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i;

// Links

export const ZILLOW_LEASES_HELP =
  'https://www.zillow.help/categories/Renter_Landlord_Property_Manager%2FLandlord_Property_Manager%2FOnline_leases';

export const TRULIA_LEASES_HELP = 'https://support.trulia.com/hc/en-us/sections/201041998';

export const HOTPADS_LEASES_HELP = 'https://help.hotpads.com/hc/en-us/sections/360003016491-Online-Leases';

export const ZILLOW_LEASES_TENANT_HELP =
  'https://www.zillow.help/article/troubleshooting-common-issues-with-signing-the-lease-zd30234403763091';

export const ZILLOW_LEASES_EMAIL = 'leases@zillow.com';

export const ZILLOW_TERMS_OF_USE = 'https://www.zillow.com/corp/Terms.htm';

export const TRULIA_TERMS_OF_USE = 'https://www.trulia.com/terms/';

export const HOTPADS_TERMS_OF_USE = 'https://www.zillow.com/corp/Terms.htm'; // No hotpads terms of use

export const ZILLOW_RENTER_TERMS_OF_USE = 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms';

export const TRULIA_RENTER_TERMS_OF_USE = 'https://www.trulia.com/renter-hub/terms/Rental-User-Terms';

export const HOTPADS_RENTER_TERMS_OF_USE = 'https://www.hotpads.com/renter-hub/terms/Rental-User-Terms';

export const REGISTER_TO_VOTE_LINK = 'https://register.vote.org/'; // Old Zillow branded link: https://p2a.co/CYViQpw/

export const ZILLOW_TERMS_OF_USE_LINKS = {
  TERMS_OF_USE: ZILLOW_TERMS_OF_USE,
  RENTER_TERMS_OF_USE: ZILLOW_RENTER_TERMS_OF_USE,
};

// Other string constants

export const MAX_AMOUNT_ERROR_MESSAGE = (amount: number) => {
  return `Amount cannot be more than $${amount.toLocaleString('en-US')}`;
};

export const ZILLOW_LEASES = 'Zillow Leases';

export const WAITLIST_NOTIFICATION_BODY = `You’re on the list! You will be notified once ${ZILLOW_LEASES} becomes available in your area.`;

export const WAITLIST_ERROR_NOTIFICATION_BODY = `We can’t process your request right now. Try again later.`;

export const FEE_PAYMENT_TIME = {
  FIRST_PAY_ON_SIGN: 'firstPayOnSign',
  FIRST_PAY_ON_LEASE_START: 'firstPayOnLeaseStart',
  TWO_EQUAL_INSTALLMENTS: 'twoEqualInstallments',
  THREE_EQUAL_INSTALLMENTS: 'threeEqualInstallments',
};

export const SCROLL_TO_ANCHOR = 'scroll-to-anchor';

export const DATE_PICKER_FORMAT = 'LLLL d, yyyy';

export const CANCEL = 'Cancel';

export const SUPPLEMENTAL_DOCUMENT_MAP = {
  hasCondoAssociationRules: 'Homeowners or condo association rules',
  hasEasementsCovenantsConditionsAndRestrictions: 'Easements, covenants, conditions, or restrictions',
  hasRelatedLeadReports: 'Lead based paint hazard reports & documents',
};

export const UTILITIES_HEADING_AND_CONTENT = {
  option1Heading: 'Tenant',
  option1Content: 'Responsible for account set up and direct payments to specified service provider',
  option2Heading: 'Landlord',
  option2Content: 'Responsible for account set up and will bill tenant separately',
};

export const CANCELLATION_REASON =
  'Signing has been canceled for this lease, as the lease is being edited. We‘ll let you know when there are updates.';

export const CANCELLATION_REASON_LEASE_EXTENSION =
  'Signing has been canceled for this lease renewal agreement, as the agreement is being edited. We‘ll let you know when there are updates.';

// Rental Protection

export const ZILLOW_INSURANCE_SERVICES = 'Zillow Insurance Services';

export const RENTAL_PROTECTION_EMAIL = 'rentalprotection@zillowgroup.com';

// End of Rental Protection

export const PAGINATION_NUMBER_OF_RESULTS = 5;

export enum WIZARD_SCREEN_TYPES {
  ARE_YOU_PLANNING_TO_SELL = 'are-you-planning-to-sell',
  CONGRATULATIONS_IS_YOUR_NEW_LEASE_READY = 'congratulations-is-your-new-lease-ready',
  HAVE_YOU_ALREADY_FOUND_YOUR_NEW_TENANTS = 'have-you-already-found-your-new-tenants',
  STEPS_TO_TAKE_TO_FIND_YOUR_NEXT_TENANTS = 'steps-to-take-to-find-your-next-tenants',
  UPDATE_YOUR_CURRENT_TERMS_WITH_A_LEASE_RENEWAL_AGREEMENT = 'update-your-current-terms-with-a-lease-renewal-agreement',
  WHAT_ARE_THE_PLANS_WITH_YOUR_CURRENT_TENANTS = 'what-are-your-plans-with-your-current-tenants',
  WHAT_DO_YOU_WANT_TO_DO_WITH_YOUR_LEASE = 'what-do-you-want-to-do-with-your-lease',
  WHAT_DO_YOU_WANT_TO_DO_WITH_YOUR_LEASE_NO_UPDATE = 'what-do-you-want-to-do-with-your-lease-no-update',
  WHAT_TO_DO_WHEN_A_LEASE_IS_ENDING = 'what-to-do-when-a-lease-is-ending',
  YOUR_UPCOMING_LEASE_TERM_WILL_BE_MONTH_TO_MONTH = 'your-upcoming-lease-term-will-be-month-to-month',
  YOURE_ALL_SET = 'youre-all-set',
}

export enum EXTERNAL_WIZARD_OPTIONS {
  SEND_TO_PROPERTY_DASHBOARD = 'send-to-property-dashboard',
  SEND_TO_SELLING = 'send-to-selling',
  CREATE_LEASE = 'create-lease',
}
export interface WizardScreen {
  component: React.ReactElement;
  primaryActionButtonText?: string;
  showSecondaryActionButton: boolean;
  showPrimaryActionButton: boolean;
  needsSelection: boolean;
}

export const RENTAL_PROTECTION_MODULE_ID = 'rentalProtectionModuleId';

export const tagTextStatusMap = {
  [LeaseStatus.COMPLETE_DRAFT]: 'Draft Completed',
  [LeaseStatus.COUNTERSIGNING]: 'Countersigning',
  [LeaseStatus.INCOMPLETE_DRAFT]: 'Draft Incomplete',
  [LeaseStatus.SENT_COMPLETE_DRAFT]: 'Draft Completed',
  [LeaseStatus.SENT_FOR_OFFLINE_SIGNING]: 'Signed Offline',
  [LeaseStatus.SENT_FOR_ONLINE_SIGNING]: 'Signing In Progress',
  [LeaseStatus.SENT_INCOMPLETE_DRAFT]: 'Draft Incomplete',
  [LeaseStatus.SIGNED_BY_TENANT]: 'Signing In Progress',
  [LeaseStatus.SIGNING_CANCELLED]: 'Signing Canceled',
  [LeaseStatus.SIGNING_COMPLETE]: 'Signing Completed',
  [LeaseStatus.TERMINATED]: 'Canceled',
};

export const tagColorStatusMap = {
  [LeaseStatus.ACTIVE]: 'green',
  [LeaseStatus.COMPLETE_DRAFT]: 'yellow',
  [LeaseStatus.COUNTERSIGNING]: 'red',
  [LeaseStatus.EXPIRED]: 'gray',
  [LeaseStatus.INCOMPLETE_DRAFT]: 'yellow',
  [LeaseStatus.SENT_COMPLETE_DRAFT]: 'yellow',
  [LeaseStatus.SENT_FOR_OFFLINE_SIGNING]: 'green',
  [LeaseStatus.SENT_FOR_ONLINE_SIGNING]: 'teal',
  [LeaseStatus.SENT_INCOMPLETE_DRAFT]: 'yellow',
  [LeaseStatus.SIGNED_BY_TENANT]: 'teal',
  [LeaseStatus.SIGNING_CANCELLED]: 'gray',
  [LeaseStatus.SIGNING_COMPLETE]: 'green',
  [LeaseStatus.TERMINATED]: 'gray',
};

export const LEASE_EXTENSION_DAYS_ALLOWED_BEFORE_END_DATE = 90;

export const ZILLOW_RENTAL_MANAGER_SUBMIT_REQUEST = 'https://www.zillow.com/rental-manager/submit-request';

export const DOWNLOAD_TOAST_MESSAGES = {
  LEASE_SUCCESS: 'Lease downloaded successfully',
  LEASE_ERROR: 'Lease download failed, try again later',
  LEASE_DRAFT_SUCCESS: 'Lease draft downloaded successfully',
  LEASE_DRAFT_ERROR: 'Lease draft download failed, try again later',
  LEASE_EXTENSION_SUCCESS: 'Lease extension downloaded successfully',
  LEASE_EXTENSION_ERROR: 'Lease extension download failed, try again later',
  LEASE_EXTENSION_DRAFT_SUCCESS: 'Lease extension draft downloaded successfully',
  LEASE_EXTENSION_DRAFT_ERROR: 'Lease extension draft download failed, try again later',
};
